import React from "react";
import { Heading, Slide, Image, FlexBox, Appear, Notes } from "spectacle";
import OpentelemetryHorizontalLogo from "../images/opentelemetry-horizontal-color.png";
export var ThankYouSlide = function () { return (React.createElement(Slide, { backgroundColor: "rgb(255, 255, 255)" },
    React.createElement(Heading, { fontSize: "h3", className: "text-black" }, "Thank you"),
    React.createElement(Appear, null,
        React.createElement(FlexBox, { justifyContent: "center", alignContent: "center", height: "100%", flexDirection: "column" },
            React.createElement(Heading, { fontSize: "h3", className: "text-black" }, "Contribute to"),
            React.createElement(Image, { src: OpentelemetryHorizontalLogo, width: 600 }))),
    React.createElement(Notes, null, "Thank you very much for your attention. Don't forget to contribute to OpenTelemetry, at least take a look at it, the thing is growing."))); };
